import { agentAuthHeaders } from './functionAuth';
import { getApiUrl } from './platform';
import { getHomeownerToken } from './storage';

function functionUrl(name) {
  return getApiUrl(`/.netlify/functions/${name}`);
}

async function assignmentHeaders() {
  const token = await getHomeownerToken();
  if (token) {
    return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
  }
  return agentAuthHeaders();
}

async function postAssignment(clientId, propertyType, features, replace) {
  const response = await fetch(functionUrl('assign-client-tasks'), {
    method: 'POST',
    headers: await assignmentHeaders(),
    body: JSON.stringify({
      clientId,
      propertyType,
      features: features || [],
      replace: replace === true,
    }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.success === false) {
    const error = new Error(result.error || 'Could not assign tasks');
    error.status = response.status;
    throw error;
  }
  return result.count || 0;
}

export const autoAssignTasks = async (clientId, agentId, propertyType, features = []) => {
  const count = await postAssignment(clientId, propertyType, features, false);
  if (count > 0 && !(await getHomeownerToken())) {
    try {
      await fetch(functionUrl('notify-task-update'), {
        method: 'POST',
        headers: await agentAuthHeaders(),
        body: JSON.stringify({
          task_id: 'bulk',
          homeowner_id: clientId,
          type: 'assigned',
          count,
        }),
      });
    } catch (error) {
      console.error('Failed to send push notification:', error);
    }
  }
  return count;
};

export const reassignTasks = async (clientId, agentId, propertyType, features) => {
  return postAssignment(clientId, propertyType, features, true);
};
